/* import __COLOCATED_TEMPLATE__ from './fin-tasks-editor-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import templateOnlyComponent from '@ember/component/template-only';
import type FinTasksEditorPayload from 'embercom/components/workflows/graph-editor/node-items/steps/fin-custom';

interface Signature {
  Args: {
    model: {
      open?: boolean;
      onClose: () => void;
      finTasksEditorPayload: FinTasksEditorPayload;
    };
  };
}

const FinTasksEditorSheet = templateOnlyComponent<Signature>();
export default FinTasksEditorSheet;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Workflows::FinTasksEditorSheet': typeof FinTasksEditorSheet;
    'react/workflows/fin-tasks-editor-sheet': typeof FinTasksEditorSheet;
  }
}
